module.exports = __webpack_public_path__ + "static/media/vidyard.c1d5c63b.png";